import JournalBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import HeroBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import TrustBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import FaqsBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import ComplianceBarBlock from "../../models/blocks/ComplianceBarBlock";
import PageHeaderBlock from "../../models/blocks/PageHeaderBlock";
import LinkBlock from "../../models/blocks/LinkBlock";
import PageFooterBlock from "../../models/blocks/PageFooterBlock";
import FooterLinksBlock from "../../models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "../../models/blocks/FooterBenefitsBlock";
import AnnouncementBarBlock from "../../models/blocks/AnnouncementBarBlock";
export default {
  [AnnouncementBarBlock.NAME]: {
    default_announcement: {
      [ComplianceBarBlock.getTextAttributeName()]: 'شحن مجاني اليوم!'
    }
  },
  [ComplianceBarBlock.NAME]: {
    default_compliance: {
      [ComplianceBarBlock.getTextAttributeName()]: 'حقوق الطبع والنشر © {from}-{to} . جميع الحقوق محفوظة.'
    }
  },
  [PageHeaderBlock.NAME]: {
    default_header: {
      [PageHeaderBlock.getLinksAttributeName()]: [{
        [LinkBlock.getNameAttributeName()]: 'الصفحة الرئيسية'
      }, {
        [LinkBlock.getNameAttributeName()]: 'منتجات'
      }, {
        [LinkBlock.getNameAttributeName()]: 'الأسئلة المتداولة'
      }, {
        [LinkBlock.getNameAttributeName()]: 'معلومات عنا'
      }, {
        [LinkBlock.getNameAttributeName()]: 'الإتصال'
      }]
    }
  },
  [PageFooterBlock.NAME]: {
    default_footer: {
      [PageFooterBlock.getSectionsAttributeName()]: [{}, {
        [FooterLinksBlock.getTitleAttributeName()]: 'معلومات',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'الشحن والارجاع'
        }, {
          [LinkBlock.getNameAttributeName()]: 'الأسئلة المتداولة'
        }, {
          [LinkBlock.getNameAttributeName()]: 'معلومات عنا'
        }, {
          [LinkBlock.getNameAttributeName()]: 'الإتصال'
        }]
      }, {
        [FooterLinksBlock.getTitleAttributeName()]: 'الصفحات القانونية',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'شروط الخدمة'
        }, {
          [LinkBlock.getNameAttributeName()]: 'سياسة الخصوصية'
        }, {
          [LinkBlock.getNameAttributeName()]: 'الإسترداد'
        }]
      }, {
        [FooterBenefitsBlock.getParagraphAttributeName()]: '<p style="text-align: justify" dir="rtl"><strong>دفع امن</strong></p><p style="text-align: justify" dir="rtl"><strong>الشحن المجاني والتسليم السريع( من 2 إلى 5 أيام )</strong></p>'
      }]
    }
  },
  [HeroBlockForm.NAME]: {
    home: {
      text: '<p style="text-align: justify; padding: 0.1px" dir="rtl">' + '<span style="font-size: 20pt; color: #FFFFFF">تجربة تسوق مذهلة عبر الإنترنت!</span>' + '</p>' + '<p style="text-align: justify; padding: 0.1px" dir="rtl"></p>' + '<ul style="text-align: justify; padding-inline-start: 24px" dir="rtl">' + '<li style="color: #FFFFFF" dir="rtl"><p style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">منتجات ذات جودة عالية</span></p></li>' + '<li style="color: #FFFFFF" dir="rtl"><p style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">تخفيضات كبيرة</span></p></li>' + '<li style="color: #FFFFFF" dir="rtl"><p style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">توصيل سريع</span></p><p dir="rtl" style="padding: 0.1px"></p></li>' + '</ul>' + '<p style="text-align: justify; padding: 0.1px" dir="rtl">' + '<span style="font-size: 20pt; color: #FFFFFF">لا تتردد! سوف تحب منتجاتنا</span>' + '</p>',
      button_text: 'إكتشف منتجاتنا'
    }
  },
  [ProductListBlockForm.NAME]: {
    discover_products: {
      title: 'إكتشف منتجاتنا'
    }
  },
  [JournalBlockForm.NAME]: {
    amazing_delivery_experience: {
      title: 'تجربة شراء ممتعة',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="rtl">يمكنك وضع طلبك في متجرنا براحة البال ، فقد عقدنا شراكة مع أفضل شركات الشحن في {country_name} لنوفر لك شحن سريع من 2 إلى 5 أيام ، وطريقة دفع آمنة نقدًا أو بالبطاقة عند الإستلام.</p>'
    },
    best_customer_service: {
      title: 'أفضل خدمة عملاء',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="rtl">فريق خدمة عملائنا موجودة دائمًا للإجابة على أسئلتك ومساعدتك في الشراء ، وكذلك في ما بعد البيع.نبذل قصارى جهدنا للإجابة على جميع عملائنا في أقل من 24 ساعة. إذا كان لديك أي أسئلة ، يرجى الاتصال بنا من <a target="_blank" rel="noopener noreferrer nofollow" href="/contact"><strong>هذه الصفحة</strong></a></p>'
    },
    about_us: {
      title: 'معلومات عنا',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="rtl">:domain_title هو متجر على الإنترنت في :country_name متخصص في المنتجات والإكسسوارات المبتكرة التي ستجعل حياتك اليومية أسهل وأكثر متعة. نبذل قصارى جهدنا لتقديم دعم في المستوى، وأوقات شحن أسرع لعملائنا. نعدك بمعالجة طلباتك في أقل من 24 ساعة، والإجابة على جميع أسئلتك في الوقت المحدد.يسعدنا أن نرحب بكم في متجرنا ، ولا تتردد في تقديم الطلبات في أي وقت :) رضاك هو هدفنا.</p>'
    }
  },
  [TrustBlockForm.NAME]: {
    satisfaction_guarantee: {
      title: 'رضاكم هو هدفنا',
      paragraph: 'نقدم شحنًا مجانيًا لجميع المنتجات ، ونمنحك 30 يومًا من الضمان لاختبار المنتج بكل راحة',
      badges_list: [{
        text: 'الشحن مجانا'
      }, {
        text: 'ضمان الإرجاع'
      }, {
        text: 'شراء آمن'
      }, {
        text: 'دعم عملاء سريع'
      }]
    }
  },
  [FaqsBlockForm.NAME]: {
    home: {
      title: 'الأسئلة المتداولة',
      other_questions_title: 'هل لديك أسئلة أخرى ؟',
      other_questions_text: '<p style="color: #FFFFFF; text-align: center; padding: 0.1px" dir="rtl">قم بزيارة صفحة التواصل، وأرسل لنا رسالتك. سوف نبذل قصارى جهدنا للإجابة على جميع عملائنا في أقل من 24 ساعة</p>',
      other_questions_button_text: 'Contact us',
      faqs_list: [{
        title: 'كيف يمكنني متابعة  مشترياتي ؟',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="rtl"><span>سوف نرسل رقم التتبع عن طريق البريد الإلكتروني مباشرة بعد شحن طلبك.</span></p>'
      }, {
        title: 'ماذا لو كنت بحاجة إلى إعادة المنتج ؟',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="rtl"><span>لا تقلق! اتصل بنا في أقرب وقت ممكن في أول 7 أيام من استلام طلبك ، وسنساعدك في معالجة الإرجاع والاسترداد أو الاستبدال.</span></p>'
      }, {
        title: 'ما هي المدة التي يستغرقها الحصول على طلبي ؟',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="rtl"><span>سيتم تسليم طلبك في غضون 2-5 أيام من تأكيد الطلب ، اعتمادًا على حجم الطلبات المستلمة إذا كان هناك أي تأخير في استلام طلبك ، فيرجى الاتصال بنا وسنساعدك في تأكيد حالة طلبك.</span></p>'
      }, {
        title: 'ما هي إمكانيات الدفع ؟',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="rtl"><span>يمكنكم الدفع نقدًا أو بالبطاقة عند الاستلام.</span></p>'
      }, {
        title: 'ماذا يحدث إذا تضررت مشترياتي أو فقدت ؟',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="rtl"><span>نحن نأخذ هذه القضايا على محمل الجد وسنتعامل معها على أساس كل حالة على حدة لمزيد من المعلومات حول سياسة الإرجاع والاسترداد ، يرجى مراجعة </span><a target="_blank" rel="noopener noreferrer nofollow" href="/shipping-return-policy"><span><strong>هذه الصفحة</strong></span></a><span>.</span></p>'
      }]
    }
  }
};